import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {AuxiliarService} from '../../services/auxiliar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-transition-page',
  templateUrl: './transition-page.component.html',
  styleUrls: ['./transition-page.component.scss']
})
export class TransitionPageComponent implements OnDestroy {
  @ViewChild('wrapper') wrapper: ElementRef;

  public logo: string = `./assets/img/brand/${environment.company}_white.svg`;
  public show: boolean;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private auxiliarService: AuxiliarService) {
    // observable to trigger show/hide transition page
    this.auxiliarService.transitionPageObservable.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (!value && this.wrapper) {
        this.wrapper.nativeElement.classList.remove('animate__fadeInDown');
        this.wrapper.nativeElement.classList.add('animate__fadeOut');
        setTimeout(() => {
          this.show = value;
          this.wrapper.nativeElement.classList.add('animate__fadeInDown');
          this.wrapper.nativeElement.classList.remove('animate__fadeOut');
        }, 1000);
      } else {
        this.show = value;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
